import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import Button from '../../../../../../../../shared/components/buttons/Button';
import { defineAccountType } from '../../../../../../../../utils/businessRule';
import {
  capitalize,
  celMask,
  cpfCnpjMask,
} from '../../../../../../../../utils/masks';
import { IBankInfoModal } from '../../interface';
import Info from './components/Info';
import Wrapper from './components/Wrapper';

function BankInfoModal(props: IBankInfoModal) {
  return (
    <Modal
      show={props.show}
      onHide={props.onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {`${capitalize(props.data?.companyName)} : ${capitalize(
            props.data?.partner
          )}`}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Wrapper.Base>
          <Info.Title>Dados Básicos</Info.Title>
          <Wrapper.Row>
            <Wrapper.Info>
              <Info.Label>CPF/CNPJ:</Info.Label>
              <Info.Value>{cpfCnpjMask(props.data?.cnpjCpf)}</Info.Value>
            </Wrapper.Info>
            <Wrapper.Info>
              <Info.Label>Cel:</Info.Label>
              <Info.Value>{celMask(props.data?.cel)}</Info.Value>
            </Wrapper.Info>
            <Wrapper.Info>
              <Info.Label>E-mail:</Info.Label>
              <OverlayTrigger
                placement="bottom"
                delay={{ show: 250, hide: 400 }}
                overlay={<Tooltip id="email">{props.data?.email}</Tooltip>}>
                <Info.Value>{props.data?.email}</Info.Value>
              </OverlayTrigger>
            </Wrapper.Info>
          </Wrapper.Row>
          <Info.Title>Bancário:</Info.Title>
          <Wrapper.Row>
            <Wrapper.Info>
              <Info.Label>Tipo:</Info.Label>
              <Info.Value>
                {defineAccountType(props.data?.accountFormat)}
              </Info.Value>
            </Wrapper.Info>
            <Wrapper.Info>
              <Info.Label>Agência:</Info.Label>
              <Info.Value>{props.data?.agency}</Info.Value>
            </Wrapper.Info>
            <Wrapper.Info>
              <Info.Label>Conta:</Info.Label>
              <Info.Value>{props.data?.account}</Info.Value>
            </Wrapper.Info>
            <Wrapper.Info>
              <Info.Label>Digito:</Info.Label>
              <Info.Value>{props.data?.digit}</Info.Value>
            </Wrapper.Info>
          </Wrapper.Row>
        </Wrapper.Base>
      </Modal.Body>
      <Modal.Footer
        style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
        <Button.Default onClick={props.onHide}>Fechar</Button.Default>
      </Modal.Footer>
    </Modal>
  );
}

export default BankInfoModal;
